import Drawer from 'react-modern-drawer';
import React, { useEffect, useState } from "react";
import ReportsServices from './ReportsServices';
import { CommonUtilities } from 'commonUtils';

export default function ReportingInvoices(param: any) {


    const [editParam, setEditParam] = useState<any>([]);

    const closeReportingInvoices = () => {
        param.closeReportingInvoices()
    }

    const saveReportingsReferences = () => {

        console.log(editParam)
        ReportsServices.processReferenceSave(editParam)
        //manualReference
    }

    const currentYear = new Date().getFullYear();
    const maxYear = currentYear + 5;

    const years = Array.from(
        { length: maxYear - 2014 + 1 },
        (_, i) => {
            const year = 2014 + i;

            return {
                value: year.toString(),
                label: year.toString(),
            };
        }
    );

    return (
        <Drawer open={param.ReportingInvoicesOpen} onClose={closeReportingInvoices} direction='right' >

            <div className="box noBorderRadius noBorder full-height-vh  pull-left ws-4">

                <div className="box-header-main">
                    <h2>Reporting Invoices</h2>
                </div>

                <div className="box-content">

                    <div className="ws-12">
                        <div className="ws-12 pm">
                            <label className="ws-12 text-bold">Manual Reference</label>
                            <input type="text" className="ws-12" value={editParam.manualReference ?? ""} onChange={(e: any) => setEditParam({ ...editParam, manualReference: e.target.value })} />
                        </div>

                        <div className="ws-12 pm">
                            <label className="ws-12 text-bold">Year</label>
                            <select className="ws-12 text-uppercase" value={editParam.yearNumber ?? ""} onChange={(e: any) => setEditParam({ ...editParam, yearNumber: e.target.value })}>
                                <option>Choose Year</option>

                                {years.map((year) => (
                                    <option key={year.value} value={year.value}>  {year.label}   </option>
                                ))}
                            </select>


                        </div>

                        <div className="ws-12 pm">
                            <label className="ws-12 text-bold">Week Number</label>
                            <input type="text" className="text-uppercase ws-12" required name="weekNumber" value={editParam.weekNumber ?? ""} onChange={(e: any) => setEditParam({ ...editParam, weekNumber: e.target.value })} />
                        </div>

                    </div>

                    <div className="box-footer">
                        <button className="icon-btn edit pull-right" onClick={saveReportingsReferences}><i className="icon-floppy"></i>Save</button>
                        <button className="icon-btn delete pull-right"><i className="icon-refresh2"></i>Reset</button>
                        <button className="icon-btn delete pull-right" onClick={closeReportingInvoices}>Close</button>
                    </div>
                </div>
            </div>

        </Drawer>
    )
}